/** Textos da gravação da chamada (PT-BR). A tela decide pelo `code` do backend, nunca pelo texto da mensagem. */

export const RECORDING_ERROR_TEXT = Object.freeze({
    RECORDING_NOT_IN_PLAN: 'A gravação de chamadas não está disponível no seu plano do Otto.',
    RECORDINGS_EXHAUSTED: 'Você usou todas as gravações deste mês no seu plano do Otto.',
    RECORDING_UNAVAILABLE: 'A gravação não está disponível no momento. Tente de novo em instantes.',
    VIDEO_CALL_NOT_ACTIVE: 'A gravação só pode começar com a chamada em andamento.',
    RECORDING_ALREADY_RUNNING: 'Esta chamada já está sendo gravada.',
    RECORDING_ALREADY_REQUESTED: 'Já existe um pedido de gravação esperando a resposta.',
    RECORDING_NOT_SUPPORTED_WITH_APP: 'A gravação ainda não está disponível em chamadas com o contato pelo aplicativo.',
    NOT_CALL_OWNER: 'Só quem criou a chamada pode gravá-la.',
    NO_RECORDING_RUNNING: 'Esta chamada não está sendo gravada.',
    RECORDING_STOP_FAILED: 'Não foi possível parar a gravação agora. Tente de novo.',
    RECORDING_DELETE_FAILED: 'Não foi possível apagar a gravação agora. Tente de novo.',
    RECORDING_IN_PROGRESS: 'A gravação ainda está em andamento. Pare a gravação primeiro.',
    RECORDING_NOT_FOUND: 'Esta gravação não existe mais.',
    RECORDING_EXPIRED: 'Esta gravação passou da guarda do plano e não está mais disponível.',
    RECORDING_NOT_READY: 'A gravação ainda está sendo preparada. Tente de novo em instantes.',
    RECORDING_DOWNLOAD_NOT_IN_PLAN: 'Baixar a gravação não está disponível no seu plano do Otto.',
});

export const RECORDING_FALLBACK_ERROR = 'Não foi possível concluir agora. Tente novamente.';

/** @param {{ code?: string }|null|undefined} error */
export const recordingErrorText = (error) => RECORDING_ERROR_TEXT[error?.code] ?? RECORDING_FALLBACK_ERROR;

/** Por que o botão de gravar está travado (o mesmo motivo que o servidor devolve em `allowance.reason`). */
export const LOCKED_REASON_TEXT = Object.freeze({
    RECORDING_NOT_IN_PLAN: RECORDING_ERROR_TEXT.RECORDING_NOT_IN_PLAN,
    RECORDINGS_EXHAUSTED: RECORDING_ERROR_TEXT.RECORDINGS_EXHAUSTED,
    RECORDING_UNAVAILABLE: RECORDING_ERROR_TEXT.RECORDING_UNAVAILABLE,
});

export const BADGE_RECORDING = 'Gravando';
export const BADGE_RECORDING_LABEL = 'Esta chamada está sendo gravada';
export const BADGE_REQUESTED_AGENT = 'Esperando o aceite para gravar';
export const BADGE_REQUESTED_GUEST = 'O atendente pediu para gravar';

export const LAST_ONE_TEXT = 'Esta é a sua última gravação do mês';

/** "3 de 5 gravações neste mês" (ou "ilimitadas"). @param {{ used: number, limit: number|null, unlimited: boolean }} allowance */
export function usageLabel({ used, limit, unlimited }) {
    if (unlimited) return 'Gravações deste mês: sem limite';
    return `${used} de ${limit} gravações neste mês`;
}

/** O aviso para o atendente quando um convidado recusa ser gravado. */
export const declinedToast = (displayName) => `${displayName || 'O convidado'} não aceitou ser gravado. A gravação não foi iniciada.`;

export const GUEST_CONSENT = Object.freeze({
    requestedTitle: 'O atendente quer gravar esta chamada',
    recordingTitle: 'Esta chamada está sendo gravada',
    what: 'A gravação inclui o vídeo, o áudio e a tela compartilhada de todos na chamada, e fica guardada pela empresa.',
    accept: 'Aceitar',
    acceptAndContinue: 'Aceitar e continuar',
    decline: 'Não aceitar',
    leave: 'Sair da chamada',
    declineRequestedHint: 'Se você não aceitar, a chamada continua e nada é gravado.',
    declineRecordingHint: 'Se você não aceitar, precisa sair da chamada.',
    error: 'Não foi possível registrar sua resposta. Tente de novo.',
});
